import React from "react"
import { BaseEmptyState, BaseEmptyStateProps } from "./BaseEmptyState"

type Props = {} & Omit<BaseEmptyStateProps, "type">

export const SecondaryEmptyState: React.FC<Props> = (props) => <BaseEmptyState type="secondary" {...props} />
